export const Tag = {
  COMPANY: "Company",
  COMPANY_LIST: "Company-LIST",

  PARTNER: "Partner",
  PARTNER_LIST: "Partner-LIST",

  PROFILE: "Profile",

  // Waypoint - Browse
  BROWSE_WAYPOINTS_LIST_MINI: "BrowseWaypointsListMini",
  BROWSE_WAYPOINTS_LIST: "BrowseWaypointsList",
  BROWSE_WAYPOINTS_SUGGESTIONS: "BrowseWaypointsSuggestions",
  BROWSE_WAYPOINTS_DISTINCT_PARTNERS: "BrowseWaypointsDistinctPartners",
  BROWSE_WAYPOINTS_DISTINCT_COMPANIES: "BrowseWaypointsDistinctCompanies",
  BROWSE_WAYPOINTS_DISTINCT_PROJECTS: "BrowseWaypointsDistinctProjects",
  BROWSE_WAYPOINTS_DISTINCT_DMAS: "BrowseWaypointsDistinctDMAs",
  BROWSE_WAYPOINTS_DISTINCT_STATUSES: "BrowseWaypointsDistinctStatuses",
  BROWSE_WAYPOINTS_DISTINCT_PREDICTED_SIZES:
    "BrowseWaypointsDistinctPredictedSizes",
  BROWSE_WAYPOINTS_DISTINCT_LEAK_TYPES: "BrowseWaypointsDistinctLeakTypes",
  BROWSE_WAYPOINTS_DISTINCT_LAST_SCHEDULED_ENGINEERS:
    "BrowseWaypointsDistinctLastScheduledEngineers",
  BROWSE_WAYPOINTS_DISTINCT_JOB_TYPE_CODES:
    "BrowseWaypointsDistinctJobTypeCodes",
  BROWSE_WAYPOINTS_DISTINCT_LAST_ACTION_BY:
    "BrowseWaypointsDistinctLastActionBy",

  // Waypoint - Single Preview
  WAYPOINT: "Waypoint",
  WAYPOINT_CORRELATIONS: "WaypointCorrelations",
  WAYPOINT_CP_SESSIONS: "WaypointCPSessions",
  WAYPOINT_HISTORY: "WaypointHistory",
  WAYPOINT_JOBS: "WaypointJobs",
  WAYPOINT_MEDIA: "WaypointMedia",
  WAYPOINT_SESSIONS: "WaypointSessions",
  WAYPOINT_SOUNDINGS: "WaypointSoundings",
  WAYPOINT_TOP_SOUNDINGS: "WaypointTopSoundings",

  // Relay - Browse
  BROWSE_RELAYS_LIST_MINI: "BrowseRelaysListMini",
  BROWSE_RELAYS_LIST: "BrowseRelaysList",
  BROWSE_RELAYS_SUGGESTIONS: "BrowseRelaysSuggestions",
  BROWSE_RELAYS_DISTINCT_PARTNERS: "BrowseRelaysDistinctPartners",
  BROWSE_RELAYS_DISTINCT_COMPANIES: "BrowseRelaysDistinctCompanies",
  BROWSE_RELAYS_DISTINCT_PROJECTS: "BrowseRelaysDistinctProjects",
  BROWSE_RELAYS_DISTINCT_DMAS: "BrowseRelaysDistinctDMAs",
  BROWSE_RELAYS_DISTINCT_STATUSES: "BrowseRelaysDistinctStatuses",
  BROWSE_RELAYS_COUNT: "BrowseRelaysCount",

  // GIS
  GIS_COLUMN_AND_SAMPLE_DATA: "GISColumnAndSampleData",

  GIS_UPLOAD: "GISUpload",

  GIS_UPLOAD_DATA: "GISUploadData",

  // Project
  PROJECT: "Project",
  PROJECT_LIST: "Project-LIST",

  // Relay
  RELAY: "Relay",

  // Sensor - Single Preview
  SENSOR: "Sensor",

  // Sensor - Browse
  BROWSE_SENSORS_LIST_MINI: "BrowseSensorsListMini",
  BROWSE_SENSORS_LIST: "BrowseSensorsList",
  BROWSE_SENSORS_SUGGESTIONS: "BrowseSensorsSuggestions",
  BROWSE_SENSORS_DISTINCT_COLLECTED_BY: "BrowseSensorsDistinctCollectedBy",
  BROWSE_SENSORS_DISTINCT_COMPANIES: "BrowseSensorsDistinctCompanies",
  BROWSE_SENSORS_DISTINCT_DEPLOYED_BY: "BrowseSensorsDistinctDeployedBy",
  BROWSE_SENSORS_DISTINCT_DMAS: "BrowseSensorsDistinctDMAs",
  BROWSE_SENSORS_DISTINCT_PARTNERS: "BrowseSensorsDistinctPartners",
  BROWSE_SENSORS_DISTINCT_PROJECTS: "BrowseSensorsDistinctProjects",
  BROWSE_SENSORS_DISTINCT_TYPE: "BrowseSensorsDistinctType",

  // Session - Browse
  BROWSE_SESSIONS_DISTINCT_COMPANIES: "BrowseSessionsDistinctCompanies",
  BROWSE_SESSIONS_DISTINCT_COLLECTED_BY: "BrowseSessionsDistinctCollectedBy",
  BROWSE_SESSIONS_DISTINCT_DEPLOYED_BY: "BrowseSessionsDistinctDeployedBy",
  BROWSE_SESSIONS_DISTINCT_DMAS: "BrowseSessionsDistinctDMAs",
  BROWSE_SESSIONS_DISTINCT_PARTNERS: "BrowseSessionsDistinctPartners",
  BROWSE_SESSIONS_DISTINCT_PROJECTS: "BrowseSessionsDistinctProjects",
  BROWSE_SESSIONS_DISTINCT_PREDICTED_SIZES:
    "BrowseSessionsDistinctPredictedSizes",
  BROWSE_SESSIONS_DISTINCT_STATUSES: "BrowseSessionsDistinctStatuses",
  BROWSE_SESSIONS_DISTINCT_TYPES: "BrowseSessionsDistinctTypes",
  BROWSE_SESSIONS_LIST_MINI: "BrowseSessionsListMini",
  BROWSE_SESSIONS_LIST: "BrowseSessionsList",
  BROWSE_SESSIONS_SUGGESTIONS: "BrowseSessionsSuggestions",

  // Session - Single Preview
  SESSION: "Session",
  SESSION_MEDIA: "SessionMedia",

  // Logs
  RECENT_ACTIVITY: "RecentActivity",
  RECENT_ACTIVITY_LIST: "RecentActivity-LIST",

  // Map
  MAP_LAYER_DMAS: "MapLayerDMAs",
  MAP_LAYER_ASSETS: "MapLayerAssets",
  MAP_LAYER_PIPES: "MapLayerPipes",
  MAP_LAYER_SENSORS: "MapLayerSensors",
  MAP_LAYER_SESSIONS: "MapLayerSessions",
  MAP_LAYER_WAYPOINTS: "MapLayerWaypoints",
  MAP_LAYER_RELAYS: "MapLayerRelays",

  // Custom views (filters)
  CUSTOM_VIEW: "CustomView"
} as const;
